<template>
  <div class="battery-add">
    <div class="row">
      <div class="label">设备编号</div>
      <div class="row-right">{{ deviceNo }}</div>
    </div>
    <div class="row">
      <div class="label">电池二维码</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="linkNumber"></el-input>
        <el-upload
          style="display: inline-block"
          action=""
          accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="uploadQrcode">
          <span class="text-btn ml10" style="color: #67aa42">上传二维码</span>
        </el-upload>
      </div>
    </div>
    <div class="row">
      <div class="label">通讯板编号</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="communicationBoardNo"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">电池规格</div>
      <div class="row-right">
        <el-radio-group v-model="ratedVoltageStandard">
          <el-radio label="48">48V</el-radio>
          <el-radio label="60">60V/72V</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="row">
      <div class="label">版本</div>
      <div class="row-right">
        <el-select v-model="version">
          <el-option
            v-for="item in versionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="label">电池厂商</div>
      <div class="row-right">
        <el-select v-model="manufacturer">
          <el-option
            v-for="item in manufacturerList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="label">电池材料</div>
      <div class="row-right">
        <el-select v-model="materialType">
          <el-option
            v-for="item in materialTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn" @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'batteryMgmtRebindView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      deviceNo: '',
      linkNumber: '',
      shellNo: '',
      communicationBoardNo: '',
      ratedVoltageStandard: '',
      version: '',
      versionList: [
        {
          id: "1",
          name: "v1.0"
        },
        {
          id: "2",
          name: "v2.0"
        },
        {
          id: "3",
          name: "v3.0"
        },
        {
          id: "4",
          name: "v3.1"
        },
        {
          id: "5",
          name: "v4.0"
        }
      ],
      manufacturer: 0,
      manufacturerList: [
        {
          name: '安靠',
          id: 0,
        },
        {
          name: '慧橙',
          id: 1,
        },
        {
          name: '创明',
          id: 2,
        },
        {
          name: '光宇',
          id: 3,
        }],
      materialType: '0',
      materialTypeList: [
        {
          id: '0',
          name: '三元锂',
        },
        {
          id: '1',
          name: '磷酸铁锂',
        }
      ]
    };
  },
  watch: {
    editData: {
      handler() {
        this.deviceNo = this.editData.deviceNo;
        this.linkNumber = this.editData.linkNo;
        this.shellNo = this.editData.shellNo;
        this.communicationBoardNo = this.editData.communicationBoardNo;
        this.ratedVoltageStandard = this.editData.ratedVoltageStandard;
        this.version = this.editData.version;
        this.manufacturer = this.editData.manufacturer;
        this.materialType = this.editData.materialTypeCode;
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    uploadQrcode(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then((res) => {
        let linkNo = res.data;
        this.linkNumber = Utils.getQueryParam(linkNo, 'qrcode');
      });
    },
    confirm() {
      this.addOrEditDevice();
    },
    cancel() {
      this.$emit('cancel');
    },
    addOrEditDevice() {
      let self = this;
      let params = {
        batteryNo: this.deviceNo,
        qrCode: this.linkNumber,
        communicationBoardNo: this.communicationBoardNo,
        ratedVoltageStandard: this.ratedVoltageStandard,
        manufacturer: this.manufacturer,
        materialType: this.materialType,
        version: this.version,
        reconfirm: 0
      };
      this.$http.post('/managementPlatform/electricity/editBatteryInfo', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        if (res.mdata.needReconfirm == 1) {
          self.$confirm(res.mdata.msg, '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.reconfirm = 1;
            self.addOrEditDevice();
          }).catch(action => {
          });
        }
        self.$message({
          type: "success",
          message: "绑定成功!",
          center: true
        });
        self.$emit('editSuccess');
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 920px;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batteryMgmtRebindView.vue